"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ApproveBudgetData () {
        return ApproveBudgetData;
    },
    get ApproveBudgetRequest () {
        return ApproveBudgetRequest;
    },
    get ApproveBudgetResponse () {
        return ApproveBudgetResponse;
    },
    get ApproveBudgetRow () {
        return ApproveBudgetRow;
    },
    get AssignActingManagerRequest () {
        return AssignActingManagerRequest;
    },
    get AssignActingManagerResponse () {
        return AssignActingManagerResponse;
    },
    get BudgetDecisionData () {
        return BudgetDecisionData;
    },
    get BudgetReviewsParams () {
        return BudgetReviewsParams;
    },
    get BulkApproveBudgetRequest () {
        return BulkApproveBudgetRequest;
    },
    get EditBudgetDecisionRequest () {
        return EditBudgetDecisionRequest;
    },
    get EditBudgetDecisionResponse () {
        return EditBudgetDecisionResponse;
    }
});
const _zod = require("zod");
const _money = require("@performyard/money");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const AssignActingManagerRequest = _zod.z.object({
    cycleId: _zod.z.string(),
    currentManagerId: _zod.z.string(),
    actingManagerId: _zod.z.string()
});
const AssignActingManagerResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const ApproveBudgetRow = _zod.z.object({
    employeeId: _zod.z.string(),
    proposedIncreaseAmount: _money.transformWireMoney,
    proposedIncreasePercent: _zod.z.number().nonnegative(),
    proposedSalary: _money.transformWireMoney
});
const ApproveBudgetData = _zod.z.union([
    _zod.z.array(ApproveBudgetRow),
    _zod.z.object({
        results: _zod.z.array(ApproveBudgetRow)
    }).passthrough()
]);
const ApproveBudgetRequest = _zod.z.object({
    cycleId: _utilsisomorphic.transformObjectId,
    approverId: _utilsisomorphic.transformObjectId,
    budgetData: ApproveBudgetData
});
const ApproveBudgetResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const BulkApproveBudgetRequest = _zod.z.object({
    cycleId: _utilsisomorphic.transformObjectId,
    approverId: _utilsisomorphic.transformObjectId,
    budgetData: _zod.z.array(ApproveBudgetData)
});
const BudgetDecisionData = _zod.z.object({
    employeeBeingUpdated: _zod.z.string(),
    increasePercent: _zod.z.number().nonnegative(),
    increaseAmount: _money.transformWireMoney,
    currentSalary: _money.transformWireMoney
});
const EditBudgetDecisionRequest = _zod.z.object({
    cycleId: _zod.z.string(),
    budgetDecisionData: BudgetDecisionData
});
const EditBudgetDecisionResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const BudgetReviewsParams = _zod.z.object({
    cycleId: _utilsisomorphic.transformObjectId
});
